import TotalResults from '@/atoms/TotalResults';
import useGoogleMaps from 'hooks/googlemaps/useGoogleMaps';
import LayoutLocator from './components/LocatorLayout';
import ShopsList from './components/ShopsList';
import useStoresLocator from './hooks/useStoresLocator';
import useLocatorHeader from '@/organisms/LocatorHeader/useLocatorHeader';
import clx from 'classnames';

const ShopLocator = () => {
  const { data, totalItems, isLoading, handleClickShop } = useStoresLocator();

  const { zoomUserLocation } = useGoogleMaps();
  const { displayMap } = useLocatorHeader();

  return (
    <LayoutLocator isLoading={isLoading} onMarkerClick={handleClickShop} shops={data} total={totalItems} type="shops">
      <div
        className={clx('md:h-full w-full', {
          'md:w-1/3 md:max-h-148 md:overflow-y-auto': displayMap,
          'md:w-full': !displayMap,
        })}
      >
        {totalItems && <TotalResults className="mb-3" totalItems={totalItems} />}

        <div
          className={clx('w-full flex-col gap-4 grid ', {
            'grid-cols-1 md:grid-cols-1': displayMap,
            'grid-cols-1 md:grid-cols-2': !displayMap,
          })}
        >
          {data && <ShopsList displayDistance={zoomUserLocation} shops={data} />}
        </div>
      </div>
    </LayoutLocator>
  );
};

export default ShopLocator;
